export const DataStates = {
  LOADING : 'LOADING',
  LOADED : 'LOADED',
  RELOADING : 'RELOADING',

  ERROR : 'ERROR',
  UNDEFINED : 'UNDEFINED'
}

export const createDataWithState = (obj = {}) => {
  return {
    data: obj,
    dataState: DataStates.LOADING
  }
}